module.exports = __webpack_public_path__ + "fonts/xeicon.e4f4d6cf.woff";